import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const PrivateRoute = () => {
  const { auth } = useAuth();

  if (auth.includes('ntsa')) {
    return (
      <Navigate to="/fines/dashboard" state={{ from: location.pathname }} />
    );
  }

  if (auth.includes('officer')) {
    return <Navigate to="/fines/1" state={{ from: location.pathname }} />;
  }
  if (auth.includes('mara')) {
    return <Navigate to="/add-driver" state={{ from: location.pathname }} />;
  }
  return <Outlet />;
};

export default PrivateRoute;
